(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('UserCustom', UserCustom);

    UserCustom.$inject = ['$resource'];

    function UserCustom($resource) {


        var getCurrentUserProfile = function () {
            var resourceUrl = 'api/get-current-user-profile';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var getCurrentUserCompanies = function () {
            var resourceUrl = 'api/get-current-user-companies';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getUserByLogin = function (login) {
            var resourceUrl = 'api/get-user-by-login?login=' + login;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var createUserByAdmin = function () {

            var resourceUrl = 'api/create-company-customer-user-by-admin';
            return $resource(resourceUrl, {}, {}
            );
        };
        var setUserInsight = function () {
            var resourceUrl = 'api/v2/users/insight';
            return $resource(resourceUrl, {}, {}
            );
        }
        var updateUserInsight = function () {
            var resourceUrl = 'api/v2/users/insight';
            return $resource(resourceUrl, {}, {
                'update': {method: 'PUT'}
            }
            );
        }
        var userAttribution = function () {
            var resourceUrl = 'api/v2/users/attribution';
            return $resource(resourceUrl, {}, {
                'save': {
                    method: 'POST',
                    isArray: false,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
        });
        }

        return {
            getCurrentUserProfile: getCurrentUserProfile,
            getCurrentUserCompanies: getCurrentUserCompanies,
            getUserByLogin: getUserByLogin,
            createUserByAdmin: createUserByAdmin,
            setUserInsight:setUserInsight,
            updateUserInsight: updateUserInsight,
            userAttribution: userAttribution
        };
    }
})();
